import { FC, CSSProperties } from "react";
import classNames from "classnames";

import { StyledLoadingMessage } from "@app/components/common/LoadingElement.styles";

import { Spinner } from "@dit/ui-components.react.element.spinner";
import { isNullOrWhitespace } from "@app/core/utilities/string";
import { useDataId } from "@dit/ui-core-hooks";
import { useTranslation } from "react-i18next";

type Props = {
    loadingMessage?: string;
    size?: number;
    className?: string;
    strokeColor?: string;
};

export const LoadingElement: FC<Props> = ({ loadingMessage, size = 50, className, strokeColor }) => {
    const { getManualId } = useDataId(LoadingElement);
    const { t } = useTranslation();

    return (
        <>
            <Spinner
                data-id={getManualId("loader")}
                className={classNames("loading-element", className)}
                size={size}
                style={{ "--color-loading": strokeColor } as CSSProperties}
                aria-label={t("LoadingElement.loadingData")}
            />
            {!isNullOrWhitespace(loadingMessage) && <StyledLoadingMessage>{loadingMessage}</StyledLoadingMessage>}
        </>
    );
};
